import {
  Box,
  HStack,
  VStack,
  Image,
  Text,
  Heading,
  Button,
} from "@chakra-ui/react";
import Resume from "../files/Shubham-Pandey-Resume.pdf"
import { FaCloudDownloadAlt } from 'react-icons/fa'
import { Link } from "react-scroll";
import { Title } from "./Title";

export function Home() {
  return (
    <div >
      <Box id="home" className="home">
        <HStack
          // border={"1px solid green"}
          justifyContent="space-evenly"
          width="88%"
          margin={"auto"}
          mt="50px"
        >
          <VStack
            //   border={"1px solid red"}
            alignItems={"flex-start"}
          >
            <Text fontSize={{ base: "md", sm: "2xl", md: "4xl" }}>
              Hi <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span> I'm
            </Text>
            <Heading
              fontSize={{ base: "xl", sm: "3xl", md: "6xl" }}
              pt="5px"
              pb="5px"
            >
              Shubham Pandey
            </Heading>
            <Text
              fontSize={{ base: "md", sm: "2xl", md: "4xl" }}
              paddingBottom="-30px"
              color={"orange.400"}
            >
              <Title/>
            </Text>
            <Text
              align={"start"}
              fontSize={{ base: "10px", sm: "15px", md: "sm" }}
              style={{ marginTop: "0px" }}
            >
              
            </Text>
            
            
            <HStack>
              
              {/* <Button style={{display:"none"}} download="Shubham-Pandey-Resume"  
                width={["60px", "60px", "100px"]}
                color={"white"}
                bgColor="#3399ff"
                fontSize={["12px", "12px", "18px"]}
                onClick={() => {
                  return window.open(
                    "https://drive.google.com/file/d/1HP44WvGLh66ptUDZnPPPNwZviKAFkOTH/view?usp=share_link",
                  );
                }}
              >
                Resume
              </Button> */}
              <button id="resume-button-2"  target="_blank" style={{fontWeight:"500", fontSize:"18px" ,color:"white", backgroundColor:"#3399ff", padding:"7px 18px", borderRadius:"7px"}}> <a   id="resume-link-2"download="Shubham-Pandey-Resume"  href={Resume}>Resume</a> </button>
              
            </HStack>
          </VStack>
          <Box >
            <Image   className="home-img"
              src={require("../files/nn.jpg")}
              borderRadius="60%"
              width={["350px", "350px", "350px"]}
            />
          </Box>
        </HStack>
      </Box>
    </div>
  );
}
